import { AccountListPageContainer } from './AccountListPageContainer';

// Route-specific presets for AccountListPageContainer
type AccountListPageProps = {
  displayUnpaidOnly: boolean;
  overage?: string;
  displayWithoutQuery: boolean;
  showOverages: boolean;
};

export const AccountListPage = (props: AccountListPageProps) => <AccountListPageContainer {...props} />;

export const OverageAccountListPage = () => (
  <AccountListPageContainer displayWithoutQuery displayUnpaidOnly={false} showOverages overage="any" />
);

export const UnpaidAccountListPage = () => (
  <AccountListPageContainer displayWithoutQuery displayUnpaidOnly showOverages={false} />
);

export const AllAccountListPage = () => (
  <AccountListPageContainer displayWithoutQuery displayUnpaidOnly={false} showOverages={false} />
);

// These components serve as prop presets for different account list views
